module.exports = __webpack_public_path__ + "static/media/interactive_training_material_design.3aa1b05b.jpg";